import { API_URL } from "../api/client.js";

export function OAuthButtons() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 20 }}>
      <a
        href={`${API_URL}/api/casual/auth/google`}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          padding: "10px 16px",
          border: "1px solid #DDD",
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          color: "#2C2C2C",
          textDecoration: "none",
          background: "#fff",
        }}
      >
        Tęsti su Google
      </a>
      <a
        href={`${API_URL}/api/casual/auth/facebook`}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          padding: "10px 16px",
          border: "1px solid #DDD",
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          color: "#2C2C2C",
          textDecoration: "none",
          background: "#fff",
        }}
      >
        Tęsti su Facebook
      </a>
    </div>
  );
}
